// /platform/audit-log — cross-tenant view платформенного audit-log'а для
// PLATFORM_ADMIN (PA-13 / PA-16 / D17 §4).
//
// Route-level guard `redirectIfNotPlatformAdmin` — distributor-scoped
// пользователь редиректится на /dashboard. Permission `platform.audit.view`
// проверяется внутри `PlatformAuditLogScreen` (warning Banner).

import { createFileRoute, redirect } from '@tanstack/react-router'
import { RequireAuth } from '@dss/auth'
import { PlatformAuditLogScreen } from '../features/platform/PlatformAuditLogScreen'
import { redirectIfNotPlatformAdmin } from '../lib/platformAdminGuard'

export const Route = createFileRoute('/platform/audit-log')({
  beforeLoad: () => {
    redirectIfNotPlatformAdmin(redirect)
  },
  component: PlatformAuditLogRoute,
})

function PlatformAuditLogRoute() {
  return (
    <RequireAuth>
      <PlatformAuditLogScreen />
    </RequireAuth>
  )
}
